import { api } from '../../../services/api/axios';

export interface ChangeEmailPayload {
  token: string;
  new_email: string;
  current_password: string;
}

export interface SendEmailPayload {
  email: string;
}

export const userSettingService = {

  changeEmail: async (payload: ChangeEmailPayload): Promise<any> => {
    try {
      const response = await api.post(`/change-email`, payload);
      return response.data;
    } catch (err: any) {
      const apiMessage = err.response?.data?.message || err.response?.data?.error;
      throw new Error(apiMessage || err.message);
    }
  },

  sendEmail: async (payload: SendEmailPayload, type: "email" | "password"): Promise<any> => {
    let config = {};
    if (type === "email") {
      const token = localStorage.getItem('token');
      if (token) {
        config = { headers: { Authorization: `Bearer ${token}` } };
      }
    }
    try {
      const response = await api.post(`/send-email/change-${type}`, payload, config);
      return response.data;
    } catch (err: any) {
      const apiMessage = err.response?.data?.message || err.response?.data?.error;
      throw new Error(apiMessage || err.message);
    }
  },
};
